import { keyBy } from 'lodash';
import { AppleNewsIcon, CellTowerIcon, EmailOutlinedIcon, WorkspacePremiumOutlinedIcon } from 'tuui';
import { CREATIVE_TYPES } from 'modules/campaigns/modules/creative-display/config/displayTypes';
import { COMMON_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';

export const SUPPLY_TARGETING_TYPES = {
    ALL: 'ALL',
    TABOOLA_SELECT: 'TABOOLA_SELECT',
    YAHOO: 'YAHOO',
    YAHOO_MOMENTS: 'YAHOO_MOMENTS',
    APPLE_NEWS: 'APPLE_NEWS',
    MAIL: 'MAIL',
    TABOOLA_CURATED: 'TABOOLA_CURATED',
    EXTENDED_PREMIUM: 'EXTENDED_PREMIUM',
};

const allOption = {
    id: SUPPLY_TARGETING_TYPES.ALL,
    value: SUPPLY_TARGETING_TYPES.ALL,
    label: 'Optimal Scale & Performance',
    icon: <CellTowerIcon />,
    enableCondition: ({ supplyTargetingResource }) => supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.ALL]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.ALL]?.isVisible ||
        campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.ALL,
    subtext: 'All Taboola Publishers and placements. Use other sections in campaign set up to refine targeting.',
};

const taboolaSelectOption = {
    id: SUPPLY_TARGETING_TYPES.TABOOLA_SELECT,
    value: SUPPLY_TARGETING_TYPES.TABOOLA_SELECT,
    label: 'Taboola Select',
    icon: <WorkspacePremiumOutlinedIcon />,
    enableCondition: ({ supplyTargetingResource }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.TABOOLA_SELECT]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.TABOOLA_SELECT]?.isVisible ||
        campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.TABOOLA_SELECT,
    subtext:
        'Package of premium placements on a curated list of  Taboola Publishers. Only for approved advertisers and must adhere to floor pricing.',
    iconsKey: COMMON_FLAGS.SUPPLY_TARGETING_ICONS_TABOOLA_SELECT,
    moreIconsKey: COMMON_FLAGS.SUPPLY_TARGETING_MORE_ICONS_NUMBER_TABOOLA_SELECT,
};

const yahooOption = {
    id: SUPPLY_TARGETING_TYPES.YAHOO,
    value: SUPPLY_TARGETING_TYPES.YAHOO,
    label: 'Yahoo O&O Only',
    enableCondition: ({ supplyTargetingResource }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.YAHOO]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.YAHOO]?.isVisible ||
        campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.YAHOO,
    iconsKey: '',
    moreIconsKey: '',
};

const appleNewsOption = {
    id: SUPPLY_TARGETING_TYPES.APPLE_NEWS,
    value: SUPPLY_TARGETING_TYPES.APPLE_NEWS,
    label: 'Apple News',
    icon: <AppleNewsIcon />,
    enableCondition: ({ supplyTargetingResource }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.APPLE_NEWS]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.APPLE_NEWS]?.isVisible ||
        campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.APPLE_NEWS,
    subtext:
        'Apple News And Apple Stocks provide highly-relevant, engaging, and brand-safe in-app content without sacrificing user privacy and trust. Available in US, CA, AU & UK only.',
};

const mailOption = {
    id: SUPPLY_TARGETING_TYPES.MAIL,
    value: SUPPLY_TARGETING_TYPES.MAIL,
    label: 'Mail',
    icon: <EmailOutlinedIcon />,
    enableCondition: ({ supplyTargetingResource }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.MAIL]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.MAIL]?.isVisible ||
        campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.MAIL,
    subtext:
        'Run a separate Mail-only campaign to exclusively target Mail supply and maximize efficiency. Top markets include US, UK, BR, IN, FR, ROU, CA, ES',
};

const premiumExtendedSupplyOption = {
    id: SUPPLY_TARGETING_TYPES.EXTENDED_PREMIUM,
    value: SUPPLY_TARGETING_TYPES.EXTENDED_PREMIUM,
    label: 'Premium Extended Supply',
    enableCondition: ({ supplyTargetingResource }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.EXTENDED_PREMIUM]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting, creativeType }) =>
        creativeType !== CREATIVE_TYPES.DISPLAY &&
        (supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.EXTENDED_PREMIUM]?.isVisible ||
            campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.EXTENDED_PREMIUM),
    iconsKey: COMMON_FLAGS.SUPPLY_TARGETING_ICONS_EXTENDED_PREMIUM,
    moreIconsKey: COMMON_FLAGS.SUPPLY_TARGETING_MORE_ICONS_NUMBER_EXTENDED_PREMIUM,
};

const yahooMomentsOption = {
    id: SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS,
    value: SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS,
    label: 'Yahoo Vertical O&O Only',
    enableCondition: ({ supplyTargetingResource, useYahooMomentsSlider }) =>
        useYahooMomentsSlider && supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting, creativeType, useYahooMomentsSlider }) =>
        creativeType === CREATIVE_TYPES.DISPLAY &&
        (supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS]?.isVisible ||
            campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS) &&
        useYahooMomentsSlider,
    subtext: 'Run this line exclusively on Vertical O&O placements',
    iconsKey: '',
    moreIconsKey: '',
};

const taboolaCuratedOption = {
    id: SUPPLY_TARGETING_TYPES.TABOOLA_CURATED,
    value: SUPPLY_TARGETING_TYPES.TABOOLA_CURATED,
    label: 'Taboola Curated',
    enableCondition: ({ supplyTargetingResource }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.TABOOLA_CURATED]?.isEditable,
    visibilityCondition: ({ supplyTargetingResource, campaignSupplyTargeting }) =>
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.TABOOLA_CURATED]?.isVisible ||
        campaignSupplyTargeting === SUPPLY_TARGETING_TYPES.TABOOLA_CURATED,
    iconsKey: COMMON_FLAGS.SUPPLY_TARGETING_ICONS_TABOOLA_CURATED,
    moreIconsKey: COMMON_FLAGS.SUPPLY_TARGETING_MORE_ICONS_NUMBER_TABOOLA_CURATED,
};

export const supplyTargetingDropdownOptions = [
    taboolaSelectOption,
    yahooOption,
    premiumExtendedSupplyOption,
    taboolaCuratedOption,
];

export const supplyTargetingRadioOptions = [allOption, appleNewsOption, mailOption];

export const supplyTargetingOptions = [
    allOption,
    taboolaSelectOption,
    yahooOption,
    yahooMomentsOption,
    appleNewsOption,
    mailOption,
    premiumExtendedSupplyOption,
    taboolaCuratedOption,
];

export const supplyTargetingSliderOptions = [
    yahooMomentsOption,
    yahooOption,
    taboolaSelectOption,
    premiumExtendedSupplyOption,
    taboolaCuratedOption,
];

export const supplyTargetingRadioOptionsByKeys = keyBy(supplyTargetingRadioOptions, 'value');
